import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import iconBusyTyping from 'assets/icons/busy-typing.png'

import Bubble from './Bubble'

const Image = styled.img`
  height: 8px;
`

const BusyTyping = ({avatar}) => {

  return (
    <Bubble
      isLeft={avatar.role !== 'bot'}
      avatar={avatar}
      endOfBlock={true}
      width='55px'
      stampStyle='none'
    >
      <Image
        src={iconBusyTyping}
      />
    </Bubble>
  )
}

BusyTyping.propTypes = {
  avatar: PropTypes.object
}

export default BusyTyping